module.exports = __webpack_public_path__ + "assets/toolbar-settings-icon.fc3335af.svg";